import { getLanguageDirection, type TextDirection } from "@/text-direction";

export const APP_LOCALES = [
  "en",
  "es",
  "fr",
  "de",
  "it",
  "pt",
  "ja",
  "ko",
  "nl",
  "pl",
  "sv",
  "no",
  "da",
  "fi",
  "cs",
  "ar",
  "bg",
  "bn",
  "el",
  "et",
  "he",
  "hi",
  "hr",
  "hu",
  "id",
  "lt",
  "ro",
  "ru",
  "sl",
  "sr",
  "sw",
  "th",
  "tr",
  "uk",
  "vi",
  "zh",
] as const;

export type AppLocale = (typeof APP_LOCALES)[number];

export const getAppLocaleDirection = (locale: AppLocale): TextDirection =>
  getLanguageDirection(locale);

const _appLocales = new Set<string>(APP_LOCALES);
// Canonical aliases and equivalents for catalogs that we actually ship.
// Unsupported languages fall back to English; never map by geographic similarity.
const _localeAliases: Partial<Record<string, AppLocale>> = {
  in: "id",
  iw: "he",
  nb: "no",
};

export const normalizeAppLocale = (
  value: string | null | undefined,
): AppLocale | undefined => {
  const primary = value
    ?.trim()
    .toLowerCase()
    .replace(/_/g, "-")
    .split("-")[0];
  if (!primary) return undefined;
  const normalized = _localeAliases[primary] || primary;
  return _appLocales.has(normalized) ? (normalized as AppLocale) : undefined;
};

export const selectAppLocale = (preferences: {
  url?: string | null;
  stored?: string | null;
  device?: string | null;
  browser?: string | null;
}): AppLocale =>
  normalizeAppLocale(preferences.url) ||
  normalizeAppLocale(preferences.stored) ||
  normalizeAppLocale(preferences.device) ||
  normalizeAppLocale(preferences.browser) ||
  "en";
